// src/components/ReportarProblema.jsx
//
// "Reportar un problema" (28-10-2026, decisión de Diego). Las Guías de la
// Comunidad (punto 8) mandan a reportar incidentes: el camino para avisar
// tiene que estar a la vista. No es un sistema de moderación: un mailto: a
// legal@ con el asunto (y el número de la solicitud, si hay) ya puestos.
// Nada en la base. El texto es el mismo que la app (components/ReportarProblema.tsx).
//
// En el chat va en texto chico y sin advertencia (Diego, 28-10): aparece en
// todas las conversaciones, también en las que van bien, y un cartel de
// advertencia le pone al producto un tono de sospecha sobre la persona con la
// que se habla. A la vista, no gritando.
//
// En un navegador sin cliente de correo, un mailto: no hace nada y no avisa:
// por eso la dirección queda escrita al lado, para copiarla.

const font = "Montserrat, sans-serif";
export const CONTACTO_REPORTES = "legal@fixo.com.ar";

// Texto de las Guías de la Comunidad v1.1, tal cual (Diego, 28-10-2026).
const CUERPO = [
  "Contanos qué pasó, cuándo, y con quién. Si tenés capturas del chat, adjuntalas.",
  "",
  "---",
  "Si algo está pasando AHORA y tu seguridad o la de alguien más está en riesgo, llamá al 911. No esperes nuestra respuesta.",
  "",
  "Si hubo un delito —violencia, amenazas, robo, daño intencional, acoso sexual—, hacé la denuncia policial. FIXO no reemplaza a la policía ni a la justicia. Avisanos igual: con la denuncia hecha podemos actuar sobre la cuenta.",
  "---",
].join("\n");

function mailto(solicitudId) {
  const asunto = solicitudId ? `Reporte de incidente — solicitud #${solicitudId}` : "Reporte de incidente";
  return `mailto:${CONTACTO_REPORTES}?subject=${encodeURIComponent(asunto)}&body=${encodeURIComponent(CUERPO)}`;
}

// variante "chat": texto chico y discreto, debajo del encabezado del chat.
// variante "fila": línea centrada, para el pie de los perfiles.
export default function ReportarProblema({ solicitudId, variante = "fila" }) {
  const chat = variante === "chat";
  return (
    <div style={{
      fontFamily: font,
      ...(chat
        ? { fontSize: 11, color: "#aab8c2", textAlign: "right", margin: "-4px 4px 10px" }
        : { fontSize: 12, color: "#5a6e7f", textAlign: "center", padding: "12px 0" }),
    }}>
      <a href={mailto(solicitudId)} style={{ color: chat ? "#7a93a4" : "#163244", fontWeight: chat ? 500 : 700, textDecoration: "underline" }}>
        {chat ? "Reportar un problema" : "⚠ Reportar un problema"}
      </a>
      {" "}· {chat ? "" : "o escribinos a "}<span style={{ fontWeight: 600, userSelect: "all" }}>{CONTACTO_REPORTES}</span>
    </div>
  );
}
